import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import useFormatter from '../../common/useFormatter';
import { getLocationMetricDescriptorsMap } from './locationMetric.default';
import {
  LocationMetric,
  LocationMetricDescriptor,
} from './locationMetric.types';

function useLocationMetricDescriptorsMap() {
  const { t } = useTranslation('dataset');
  const formatter = useFormatter();
  // const extraDescriptors = useRecoilValue(actualityExtraMetricDescriptors);

  const metrics: LocationMetricDescriptor[] = [
    {
      ...getLocationMetricDescriptorsMap(t).locationOrder,
      category: 'location',
      // title: t``,
      title: t(`Location Order`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationStatus,
      category: 'location',
      title: t(`Location Status`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationLevel,
      category: 'location',
      title: t(`Location Level`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationLength,
      category: 'location',
      title: t(`Location Length`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationWidth,
      category: 'location',
      title: t(`Location Width`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationHeight,
      category: 'location',
      title: t(`Location Height`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationWeight,
      category: 'location',
      title: t(`Location Weight`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationBayTitle,
      category: 'location',
      title: t(`Bay`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationBayPosition,
      category: 'location',
      title: t(`Bay Position`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationDepthPosition,
      category: 'location',
      title: t(`Location Depth Position`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationUsageType,
      category: 'location',
      title: t(`Location Usage Type`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locmhtype,
      category: 'location',
      title: t(`MHE Type`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationRackingType,
      category: 'location',
      title: t(`Location Type`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).warehouseArea,
      category: 'location',
      title: t(`Warehouse Area`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationSide,
      category: 'location',
      title: t(`Location Side`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).congestionZone,
      category: 'location',
      title: t(`Work Zone`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationHeightFromFloor,
      category: 'location',
      title: t(`Location Height From Floor`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationDepthFromFront,
      category: 'location',
      title: t(`Location Depth From Front`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).locationIndexFromFront,
      category: 'location',
      title: t(`Location Index From Front`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).bayType,
      category: 'location',
      title: t(`Bay Type`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).aisleTitle,
      category: 'location',
      title: t(`Aisle`, { ns: 'dataset' }),
    },
    {
      ...getLocationMetricDescriptorsMap(t).planeTitle,
      category: 'location',
      title: t(`Floor`, { ns: 'dataset' }),
    },

    // ...(extraDescriptors as any),
  ];

  const titled = _(metrics)
    .map(d => ({ ...d, titleCategory: t`Location`, subTitle: t`Location` }))
    .keyBy(d => d.type)
    .value() as Record<LocationMetric, LocationMetricDescriptor>;
  return titled;
}

export default useLocationMetricDescriptorsMap;
